





























































import FormCheckbox from "@/components/FormCheckbox.vue";
import { Credentials, Settings } from "@/types/settings";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({ components: { FormCheckbox } })
export default class SettingsCredentialsItem extends Vue {
  @Getter("settings/activeCacheSettings") settings!: Settings;

  @Prop({ required: true })
  credential!: Credentials;

  removeCredentialsButtonTitle = "Remove credentials";
  promoteCredentialsButtonTitle = "Promote credentials to primary";

  get checkboxTitleAttr(): string {
    return !this.settings.can_update_capabilities ? "Your current plan does not allow this feature" : "";
  }

  removeCredentials() {
    if (
      window.confirm(
        "Clicking OK will remove that username and password from your cache. Are you sure you want to do this?",
      )
    ) {
      this.$ga.button(this.removeCredentialsButtonTitle);
      this.$store.dispatch("settings/removeCredentials", this.credential.sasl_username);
    }
  }

  promoteCredentials() {
    if (
      window.confirm(
        "Clicking OK will promote selected secondary credentials to the primary username and password for your cache. Are you sure you want to do this?",
      )
    ) {
      this.$ga.button(this.promoteCredentialsButtonTitle);
      this.$store.dispatch("settings/promoteCredentials", this.credential.sasl_username);
    }
  }

  setCredentialsCapabilities() {
    const payload = {
      username: this.credential.sasl_username,
      capabilities: {
        write_capability: this.credential.write_capability,
        flush_capability: this.credential.flush_capability,
        api_capability: this.credential.api_capability,
      },
    };

    this.$store.dispatch("settings/setCredentialsCapabilities", payload);
  }
}
